import { cva } from "class-variance-authority";
import { cn } from '@workspace/ui/lib/utils'
import { ReactNode, JSX } from "react";

const titleVariants = cva("text-d-black font-semibold leading-8 text-2xl")

type TitleComponent = (props: { className: string }) => ReactNode

export const PageHeader = ({
  title,
  description,
}: {
  title: string | TitleComponent;
  description?: string | JSX.Element;
}) => {
  return (
    <div className="flex flex-col w-full gap-1.5">
      <span className={cn(titleVariants())}>
        {typeof title === 'string' ? title : title({ className: cn(titleVariants()) })}
      </span>
      <div className="text-lg leading-[26px]">{description}</div>
    </div>
  );
};
